var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "cloud-panel" }, [
        _c(
          "div",
          { staticClass: "cloud-card" },
          [
            _c(
              "div",
              { staticClass: "cloud-enable-row" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("el-switch", {
                  attrs: { "active-value": 1, "inactive-value": 0 },
                  on: { change: _vm.onCloudEnabledChange },
                  model: {
                    value: _vm.largeTransferConfig.enable,
                    callback: function ($$v) {
                      _vm.$set(_vm.largeTransferConfig, "enable", $$v)
                    },
                    expression: "largeTransferConfig.enable",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.largeTransferConfig.enable === 1
              ? [
                  _c("div", { staticClass: "cloud-section-title" }, [
                    _vm._v("打款策略设置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cloud-strategy-row" },
                    [
                      _c("div", { staticClass: "cloud-strategy-seg" }, [
                        _vm._v("当用户提现金额，大于等于"),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "cloud-strategy-input",
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.largeTransferConfig.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.largeTransferConfig, "amount", $$v)
                          },
                          expression: "largeTransferConfig.amount",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "cloud-strategy-seg" }, [
                        _vm._v("元时，使用"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "cloud-strategy-select",
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.largeTransferConfig.channel,
                            callback: function ($$v) {
                              _vm.$set(_vm.largeTransferConfig, "channel", $$v)
                            },
                            expression: "largeTransferConfig.channel",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "云转账", value: 1 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cloud-strategy-seg" }, [
                        _vm._v("服务进行打款"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cloud-strategy-tip-row" },
                    [
                      _c("div", { staticClass: "cloud-strategy-tip" }, [
                        _vm._v(
                          "*反之，金额不满足上述条件时，将默认使用“支付宝”或“快安支付”通道打款。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "cloud-strategy-save",
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.onSaveCloudStrategy },
                        },
                        [_vm._v("保存配置信息")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cloud-section-title cloud-third-title" },
                    [_vm._v("第三方渠道独立配置")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "cloud-sub-tabs" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cloud-sub-tab",
                        class: { active: _vm.cloudSubTab === "cloudTransfer" },
                        on: {
                          click: function ($event) {
                            _vm.cloudSubTab = "cloudTransfer"
                          },
                        },
                      },
                      [_vm._v("云转账配置")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cloud-account-header" },
                    [
                      _c("div", { staticClass: "cloud-block-title" }, [
                        _vm._v(
                          "账号管理（共 " + _vm._s(_vm.total) + " 个账号）"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.onAddAccount },
                        },
                        [_vm._v("添加账号")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.accountList, border: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "dealerId",
                          label: "平台企业 ID",
                          align: "center",
                          "min-width": "140",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "账号余额",
                          align: "center",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        scope.row.balance === null ||
                                          scope.row.balance === undefined
                                          ? "—"
                                          : scope.row.balance
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2888599979
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "账号状态",
                          align: "center",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        Number(scope.row.active) === 1
                                          ? "cloud-status-active"
                                          : "cloud-status-inactive",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            Number(scope.row.active) === 1
                                              ? "当前使用"
                                              : "未使用"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          259343883
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "创建时间",
                          align: "center",
                          "min-width": "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center", width: "380" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "cloud-account-actions" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                            plain: "",
                                            disabled:
                                              Number(scope.row.active) === 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onActiveAccount(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("设为使用")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "warning",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSyncBalance(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("余额同步")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onConfigAccount(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("配置")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "danger",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDeleteAccount(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2969711462
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cloud-pagination" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.page,
                          "page-size": _vm.size,
                          "page-sizes": [10, 20, 30, 40],
                          total: _vm.total,
                          layout: "total, prev, pager, next, sizes, jumper",
                          background: "",
                        },
                        on: {
                          "size-change": _vm.onPageSizeChange,
                          "current-change": _vm.onPageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _c("div", { staticClass: "cloud-disabled-placeholder" }, [
                  _vm._v("开启上方开关后，方可配置第三方渠道参数与打款策略。"),
                ]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.accountDialogVisible,
            title: _vm.accountDialogMode === "add" ? "配置账号" : "账号管理",
            width: "700px",
            "close-on-click-modal": false,
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.accountDialogVisible = $event
            },
            close: _vm.onAccountDialogClose,
          },
        },
        [
          _c("div", { staticClass: "cloud-dialog-section-title" }, [
            _vm._v("第三方对接参数配置"),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "accountForm",
              attrs: {
                model: _vm.accountForm,
                rules: _vm.accountRules,
                "label-width": "160px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "平台企业ID：", prop: "dealerId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.accountForm.dealerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.accountForm, "dealerId", $$v)
                      },
                      expression: "accountForm.dealerId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "综合服务主体ID：", prop: "brokerId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.accountForm.brokerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.accountForm, "brokerId", $$v)
                      },
                      expression: "accountForm.brokerId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "App Key：", prop: "yzhAppKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.accountForm.yzhAppKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.accountForm, "yzhAppKey", $$v)
                      },
                      expression: "accountForm.yzhAppKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "3DES Key：", prop: "yzh3DesKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.accountForm.yzh3DesKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.accountForm, "yzh3DesKey", $$v)
                      },
                      expression: "accountForm.yzh3DesKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "云账户公钥：", prop: "yzhRsaPublicKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.accountForm.yzhRsaPublicKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.accountForm, "yzhRsaPublicKey", $$v)
                      },
                      expression: "accountForm.yzhRsaPublicKey",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cloud-dialog-save-row" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onSaveAccountConfig },
                },
                [_vm._v("保存配置信息")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cloud-dialog-section-title" }, [
            _vm._v("平台专属密钥配置"),
          ]),
          _vm._v(" "),
          _vm.accountForm.confId
            ? _c("div", { staticClass: "cloud-warn-tip cloud-key-saved-tip" }, [
                _c("i", { staticClass: "el-icon-circle-check" }),
                _vm._v(" 参数已保存，可重置平台密钥（支持手动录入）\n    "),
              ])
            : _c("div", { staticClass: "cloud-warn-tip" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _vm._v(
                  " 请先保存上方的“第三方对接参数”，再尝试生成独立平台密钥（支持手动录入）\n    "
                ),
              ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cloud-key-panel" },
            [
              _vm.accountHasKeys
                ? [
                    _c("div", { staticClass: "cloud-key-box" }, [
                      _c("div", { staticClass: "cloud-key-label" }, [
                        _vm._v("平台公钥 (Platform Public Key)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cloud-key-value" },
                        [
                          _c("span", { staticClass: "cloud-key-text" }, [
                            _vm._v(
                              _vm._s(_vm.accountDetail.platformRsaPublicKey)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.onCopyKey(
                                    _vm.accountDetail.platformRsaPublicKey
                                  )
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cloud-key-box" }, [
                      _c("div", { staticClass: "cloud-key-label" }, [
                        _vm._v("平台私钥 (Platform Private Key)"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cloud-key-value" }, [
                        _c("span", { staticClass: "cloud-key-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.accountDetail.platformRsaPrivateKey ||
                                "未配置"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cloud-key-panel-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.onOpenKeyManualDialog },
                          },
                          [_vm._v("手动修改")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.onRegenerateKeys },
                          },
                          [_vm._v("重新生成")]
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c("div", { staticClass: "cloud-key-empty" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.accountForm.confId
                              ? "暂无密钥，请先录入或生成平台密钥"
                              : "暂无密钥，请先保存参数后再尝试录入或生成平台密钥"
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cloud-key-panel-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.onOpenKeyManualDialog },
                          },
                          [_vm._v("手动录入")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.onRegenerateKeys },
                          },
                          [_vm._v("一键生成")]
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.cloudKeysDialogVisible,
            title: "手动修改平台密钥",
            width: "700px",
            "close-on-click-modal": false,
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cloudKeysDialogVisible = $event
            },
            close: _vm.onCloudKeysDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "cloudKeysForm",
              attrs: {
                model: _vm.cloudKeysForm,
                rules: _vm.cloudKeysRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "平台公钥：", prop: "platformRsaPublicKey" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder: "请输入外部生成的RSA公钥",
                    },
                    model: {
                      value: _vm.cloudKeysForm.platformRsaPublicKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.cloudKeysForm, "platformRsaPublicKey", $$v)
                      },
                      expression: "cloudKeysForm.platformRsaPublicKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "平台私钥：", prop: "platformRsaPrivateKey" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder: "请输入外部生成的RSA私钥",
                    },
                    model: {
                      value: _vm.cloudKeysForm.platformRsaPrivateKey,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.cloudKeysForm,
                          "platformRsaPrivateKey",
                          $$v
                        )
                      },
                      expression: "cloudKeysForm.platformRsaPrivateKey",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cloud-dialog-footer" },
            [
              _c("el-button", { on: { click: _vm.onCloudKeysDialogClose } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onCloudKeysConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.cloudNewKeysDialogVisible,
            title: "确认新密钥对",
            width: "700px",
            "close-on-click-modal": false,
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cloudNewKeysDialogVisible = $event
            },
            close: _vm.onCloudNewKeysDialogClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "cloud-warn-tip",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _c("i", { staticClass: "el-icon-warning" }),
              _vm._v(
                " 请注意：新生成的私钥仅展示一次，请立即复制并妥善保存！\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cloud-new-key-box" }, [
            _c(
              "div",
              { staticClass: "cloud-key-label-row" },
              [
                _c(
                  "span",
                  {
                    staticClass: "cloud-key-label",
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [_vm._v("平台公钥 (Platform Public Key)")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.onCopyKey(
                          _vm.cloudNewKeysForm.platformRsaPublicKey
                        )
                      },
                    },
                  },
                  [_vm._v("复制")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cloud-key-single" }, [
              _vm._v(_vm._s(_vm.cloudNewKeysForm.platformRsaPublicKey || "—")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cloud-new-key-box" }, [
            _c(
              "div",
              { staticClass: "cloud-key-label-row" },
              [
                _c(
                  "span",
                  {
                    staticClass: "cloud-key-label",
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [_vm._v("平台私钥 (Platform Private Key)")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.onCopyKey(
                          _vm.cloudNewKeysForm.platformRsaPrivateKey
                        )
                      },
                    },
                  },
                  [_vm._v("复制")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cloud-key-single" }, [
              _vm._v(_vm._s(_vm.cloudNewKeysForm.platformRsaPrivateKey || "—")),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "24px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onCloudNewKeysDialogClose },
                },
                [_vm._v("我已妥善保存，关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cloud-enable-info" }, [
      _c("div", { staticClass: "cloud-enable-title" }, [
        _vm._v("启用第三方渠道打款"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cloud-enable-desc" }, [
        _vm._v("开启后，系统将根据下方设置的全额策略，自动分配提现打款通道。"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cloud-warn-tip" }, [
      _c("i", { staticClass: "el-icon-warning" }),
      _vm._v(
        " 提示：请勿随意生成替换密钥信息。替换密钥后，请务必前往云账户平台更新公钥!\n        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }